import React from 'react'
import { observer, inject } from 'mobx-react'
import Tooltip from 'components/common/Tooltip'

// Container has two kinds of Tooltips
// hover tooltip appears when mouse overlaps subscribed element
// click tooltip appears when user clicks on subscribed element
const Tooltips = ({ uiStore }) => (
  <div>
    {uiStore.showHoverTooltip && (
      <Tooltip options={uiStore.hoverTooltipOptions} />
    )}
    {uiStore.showIncomeTooltip && (
      <Tooltip options={uiStore.incomeTooltipOptions} />
    )}
    {uiStore.showPopulationTooltip && (
      <Tooltip options={uiStore.populationTooltipOptions} />
    )}
    {uiStore.showGenderTooltip && (
      <Tooltip options={uiStore.genderTooltipOptions} />
    )}
    {uiStore.showClickTooltip && (
      <Tooltip id='click-tooltip' options={uiStore.clickTooltipOptions} />
    )}
    {uiStore.showDeletePrompt && (
      <Tooltip id='delete-item-prompt' options={uiStore.deletePromptOptions} />
    )}
  </div>
)

export default inject('uiStore')(observer(Tooltips))
